import { getVirtualPortrait } from '../api/virtualPortrait';
import type { VirtualPortraitRequestOptions } from '../api/virtualPortrait';
import type { Asset } from '../store/seedanceTypes';
import {
  pickPortraitPlayableUrl,
  resolvePortraitImageUrl,
  unwrapPortraitListItem,
} from './seedancePortraitUtils';

/** 列表接口未带 URL 时，按素材 ID 拉详情补全可播放地址。 */
export async function enrichPortraitAssetsMissingUrls(
  assets: Asset[],
  groupId: string,
  projectName: string,
  options: VirtualPortraitRequestOptions,
): Promise<Asset[]> {
  const gid = groupId.trim();
  if (!gid || !assets.length) return assets;

  const missing = assets.filter((a) => !a.url?.trim() && (a.sourceAssetId || a.id).trim());
  if (!missing.length) return assets;

  const urlById = new Map<string, string>();
  await Promise.all(
    missing.map(async (asset) => {
      const sid = (asset.sourceAssetId || asset.id).trim();
      try {
        const detail = await getVirtualPortrait(sid, options);
        const raw = pickPortraitPlayableUrl(unwrapPortraitListItem(detail), asset.type);
        const url = resolvePortraitImageUrl(raw);
        if (url) urlById.set(asset.id, url);
      } catch {
        /* 单条失败不影响列表 */
      }
    }),
  );

  if (!urlById.size) return assets;
  return assets.map((a) => (urlById.has(a.id) ? { ...a, url: urlById.get(a.id)! } : a));
}
